import { Link } from "react-router-dom";
import '../../styles/member.css';
import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../components/HeaderFFF'
import Header from '../../components/Header'
import Footer from "../../components/Footer";

export default function GeorgeCorsianos() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
  
      useEffect(() => {
          const handleResize = () => {
              setIsMobile(window.innerWidth <= 991);
          };
  
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
      }, []);
  
      return(
          <>
          {isMobile ? <Header /> : <HeaderFFF />}
        <div id="team-header-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <h2>George Corsianos</h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </div>
        <div className="member-container">
            <div className="member-box">
                <div className="member-photo">
                    <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                    <div><p>Senior Partner</p><p>(905) 370-1092</p><a href="mailto:gcorsianos@clvlaw.ca">gcorsianos@clvlaw.ca</a></div>
                </div>
                <div className="member-info">
                    <p>George is the Senior Partner of Corsianos Lee Vashishth and heads up our litigation department. He handles a broad range of litigation for corporations, partnerships and other entities as well as
                        individuals in a wide variety of matters. This includes cases involving commercial transactions,
                        banking, corporate law, contracts, shareholder disputes, partnerships, real estate, construction,
                        mortgages, guarantees, commercial leases disputes, secured debt enforcement, fiduciary
                        duties and personal injury matters.<br/><br/>
                        George has built a practice through ongoing success representing clients involved in
                        acrimonious lawsuits and acting as an advisor and counsel to various privately held companies.
                        Whatever the venue, issue, or subject matter, George’s skill and experience ensures that he can
                        provide the forceful advocacy, nuanced advice, or creative solutions to meet his clients’ needs.
                        George is a preferred counsel for complex matters. Several of George’s cases are leading
decisions and are frequently cited authorities.<br/><br/>
He is not afraid to tackle difficult or complicated legal issues, such as those that often arise in
litigation. In fact, he welcomes the challenge these cases present. He is dedicated to providing
his clients with high quality advocacy and practical advice. He is committed, in each case, to the
most economical solution that is most beneficial to his client, and always considers the merits of
alternative dispute resolution, primarily mediation. However, if the matter cannot be resolved
through these methods, he will defend the rights of his clients in court.<br/><br/>
George has extensive trial experience having conducted numerous complex trials that have
established him as a prominent figure in the legal community.<br/><br/>
He regularly appears on motions and applications in the Superior Court of Justice. He has also
appeared before the Divisional Court, the Court of Appeal, the Federal Court of Canada and the
Supreme Court of Canada.<br/><br/>
George received his Specialized Honours B.A. in Sociology from York University in 1996. He
then attended Valparaiso University in Valparaiso, Indiana where he completed a Masters of
Arts Degree in Sociology in 1997. He studied law at the University of London in London,
England for two years before completing his studies at Osgoode Hall Law School. He received
his LL.B. from Osgoode Hall Law School in 2002.<br/><br/>
George is a member of The Advocates&#39; Society, The Canadian Bar Association, The Ontario
Bar Association and The Law Society of Ontario.
George is fluent in the Greek language.<br/><br/>
As an avid sports enthusiast, George maintains an active lifestyle outside of the courtroom</p>
                </div>
                <div className="member-info-box">
                        <div><h4>Practices</h4>
                        <ul>
                            <li><Link to="/fields-of-expertise/litigation">Appellate Advocacy</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Arbitration</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Breach of Contract</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Business Litigation</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Commercial Litigation</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Commercial Landlord and Tenant Litigation</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Debt Recovery</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Employment</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Injunction Proceedings</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Mortgage Enforcement</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Real Estate Litigation</Link></li>
                            <li><Link to="/fields-of-expertise/litigation">Shareholder and Partnership Disputes</Link></li>
                            <li><Link to="/fields-of-expertise/personal-injury">Personal Injury</Link></li>
                        </ul></div>
                        <div><h4>Education</h4>
                        <ul>
                            <li>B.A. (Hons.), York University</li>
                            <li>M.A., Valparaiso University</li>
                            <li>LL.B., Osgoode Hall</li>
                        </ul></div>
                        <div><h4>Qualification</h4>
                        <ul>
                            <li>Called to the Ontario Bar in 2003</li>
                        </ul></div>
                        <div><h4>Affiliations</h4>
                        <ul>
                            <li>Advocates' Society</li>
                            <li>Canadian Bar Association</li>
                            <li>Ontario Bar Association</li>
                            <li>Law Society of Ontario</li>
                        </ul></div>
                    </div>
            </div>
        </div>
        {/* nav buttons */}
            <div className="next-page-double-btn">
                <div className="next-page-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M0.840374 9.59939L10.1851 15.9612C11.3584 16.76 12.8873 15.9263 12.9941 14.4904C13.002 14.3844 12.9831 14.2785 12.9499 14.1776L10.961 8.13557L12.9499 2.09351C12.9831 1.99261 13.002 1.8867 12.9941 1.78077C12.8886 0.364848 11.397 -0.472328 10.2228 0.285009L0.878026 6.31197C-0.276088 7.05633 -0.296349 8.82552 0.840374 9.59939Z" fill="#BF9874"/>
                    </svg>
                    <p><Link to="/our-team/sara-jane-carter">Sara-Jane Carter</Link></p>
                </div>
                <div className="next-page-btn">   
                    <p><Link to="/our-team/jacob-lee">Jacob H.C. Lee</Link></p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M12.1596 6.33849L2.81487 0.29479C1.64616 -0.461075 0.12465 0.321745 0.00723972 1.67603C-0.00238562 1.78706 0.018628 1.89822 0.0551139 2.00352L2.03901 7.72912L0.055114 13.4547C0.018628 13.56 -0.00238987 13.6712 0.00725817 13.7822C0.123306 15.1176 1.60765 15.9038 2.77722 15.1872L12.122 9.46154C13.2761 8.7544 13.2963 7.07367 12.1596 6.33849Z" fill="#BF9874"/>
                    </svg>
                </div>
            </div>
    <Footer/>
    </>
  );
}